<template>
  <div class="mt-5">
    <br />
    <br />
    <br />
    <div class="row">
      <div class="col-12 mb-2">
        <button @click="refresh()" class="btn ms-auto btn0 btn-secondary">
          <i class="bi bi-arrow-clockwise"></i>
        </button>
      </div>
    </div>

    <!-- <div  class="row align-items-stretch text-secondary">
      <div class="col-12 col-xl-3 p-3">
        <div class="row align-items-center py-1 border rounded bg-white">
          <div class="col-1">
            <i class="bi bi-cart3 text-primary" :style="{ fontSize: '30px !important' }"></i>
          </div>
          <div class="col-11">
            <div class="text-center">Commandes du jour</div>
            <div class="text-center">
              <span v-if="totalTodays.orders" class="text-primary fw-bold">
                {{ totalTodays.orders.totalOrders }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-xl-3 p-3">
        <div class="row align-items-center py-1 border rounded bg-white">
          <div class="col-1">
            <i class="bi bi-window-x text-warning" :style="{ fontSize: '30px !important' }"></i>
          </div>
          <div class="col-11">
            <div class="text-center">En attente de livraison</div>
            <div class="text-center">
              <span v-if="totalTodays.orders" class="text-warning fw-bold">
                {{ totalTodays.orders.pendingDeliveryOrders }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-xl-3 p-3">
        <div class="row align-items-center py-1 border rounded bg-white">
          <div class="col-1">
            <i class="bi bi-window-dash text-danger" :style="{ fontSize: '30px !important' }"></i>
          </div>
          <div class="col-11">
            <div class="text-center">En attente de validation</div>
            <div class="text-center">
              <span v-if="totalTodays.orders" class="text-danger fw-bold">
                {{ totalTodays.orders.pendingValidationOrders }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-xl-3 p-3">
        <div class="row align-items-center py-1 border rounded bg-white">
          <div class="col-1">
            <i class="bi bi-cash-stack text-success" :style="{ fontSize: '30px !important' }"></i>
          </div>
          <div class="col-11">
            <div class="text-center">Commandes validées</div>
            <div class="text-center">
              <span v-if="totalTodays.orders" class="text-success fw-bold">
                {{ totalTodays.orders.completedOrders }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div  class="row align-items-stretch text-secondary">
      <div class="col-12 col-xl-3 p-3">
        <div class="row align-items-center py-1 border rounded bg-white">
          <div class="col-1">
            <i class="bi bi-cart3 text-primary" :style="{ fontSize: '30px !important' }"></i>
          </div>
          <div class="col-11">
            <div class="text-center">Total commandes</div>
            <div class="text-center">
              <span v-if="totalTodays.orders" class="text-primary fw-bold">
                {{ totalTodays.orders.totalOrdersAll }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-xl-3 p-3">
        <div class="row align-items-center py-1 border rounded bg-white">
          <div class="col-1">
            <i class="bi bi-window-x text-warning" :style="{ fontSize: '30px !important' }"></i>
          </div>
          <div class="col-11">
            <div class="text-center">Total en attente de livraison</div>
            <div class="text-center">
              <span v-if="totalTodays.orders" class="text-warning fw-bold">
                {{ totalTodays.orders.pendingDeliveryOrdersAll }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-xl-3 p-3">
        <div class="row align-items-center py-1 border rounded bg-white">
          <div class="col-1">
            <i class="bi bi-window-dash text-danger" :style="{ fontSize: '30px !important' }"></i>
          </div>
          <div class="col-11">
            <div class="text-center">Total en attente de validation</div>
            <div class="text-center">
              <span v-if="totalTodays.orders" class="text-danger fw-bold">
                {{ totalTodays.orders.pendingValidationOrdersAll }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-xl-3 p-3">
        <div class="row align-items-center py-1 border rounded bg-white">
          <div class="col-1">
            <i class="bi bi-cash-stack text-success" :style="{ fontSize: '30px !important' }"></i>
          </div>
          <div class="col-11">
            <div class="text-center">Total commandes validées</div>
            <div class="text-center">
              <span v-if="totalTodays.orders" class="text-success fw-bold">
                {{ totalTodays.orders.completedOrdersAll }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div> -->


    <div  class="row align-items-stretch text-secondary">



      <!-- Ventes par chèque du mois -->
      <div class="col-12 col-xl p-3">
        <div class="row align-items-center py-1 border rounded bg-white">
          <div class="col-1">
            <i class="bi bi-bank text-primary" :style="{ fontSize: '30px !important' }"></i>
          </div>
          <div class="col-11 text-center">
            <div>Crèdit</div>
            <span v-if="allTotals.sales" class="text-primary fw-bold">
              {{ allTotals.sales.totalUnpaidSale | formatWithSpaces}}
            </span>
          </div>
        </div>
      </div>


      <!-- Factures réglées du jour -->
      <div class="col-12 col-xl p-3">
        <div class="row align-items-center py-1 border rounded bg-white">
          <div class="col-1">
            <i class="bi bi-receipt text-primary" :style="{ fontSize: '30px !important' }"></i>
          </div>
          <div class="col-11 text-center">
            <div> Paiments </div>
            <span v-if="allTotals.payments" class="text-primary fw-bold">
              {{ allTotals.payments.totalPaidOldBillSale | formatWithSpaces}}
            </span>
          </div>
        </div>
      </div>

      <!-- Ventes en espèces du jour -->
      <div class="col-12 col-xl p-3">
        <div class="row align-items-center py-1 border rounded bg-white">
          <div class="col-1">
            <i class="bi bi-cash-coin text-warning" :style="{ fontSize: '30px !important' }"></i>
          </div>
          <div class="col-11 text-center">
            <div> Dépenses </div>
            <span v-if="allTotals.expenses" class="text-warning fw-bold">
              {{ allTotals.expenses.priceTotalTTCExpense | formatWithSpaces }}
            </span>
          </div>
        </div>
      </div>

      <!-- Ventes par virement du jour -->
      <div class="col-12 col-xl p-3">
        <div class="row align-items-center py-1 border rounded bg-white">
          <div class="col-1">
            <i class="bi bi-credit-card text-danger" :style="{ fontSize: '30px !important' }"></i>
          </div>
          <div class="col-11 text-center">
            <div>Virsements</div>
            <span v-if="allTotals.transactions" class="text-danger fw-bold">
              {{ allTotals.transactions.priceTotalTTCTransaction | formatWithSpaces }}
            </span>
          </div>
        </div>
      </div>

      <!-- Ventes par chèque du jour -->
      <div class="col-12 col-xl p-3">
        <div class="row align-items-center py-1 border rounded bg-light-success">
          <div class="col-1">
            <i class="bi bi-bank text-success" :style="{ fontSize: '30px !important' }"></i>
          </div>
          <div class="col-11 text-center">
            <div> Caisse </div>
            <span v-if="allTotals.checkout" class="text-success fw-bold">
              {{ allTotals.checkout.amountAtCheckout | formatWithSpaces}}
            </span>
          </div>
        </div>
      </div>
</div>


    <div  class="row">
      <div class="col-xl-6 col-12 p-1">
        <table class="table table-striped table-hover">
          <thead>
            <tr>
              <th scope="col" class="text-center" colspan="4">
                Top 10 clients avec crédits impayés
              </th>
            </tr>
            <tr>
              <th scope="col"></th>
              <th scope="col"></th>
              <th scope="col" class="text-center">

              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(credit, index) in top10Credits" :key="index++">
              <td>
                {{ index }}
              </td>

              <td>
                <span v-if="credit">
                  {{ credit.customerFullName }}
                </span>
              </td>
              <td class="text-end">
                <span class="text-danger fw-bold">

                  {{
                  parseFloat(credit.totalUnpaid).toFixed(2) | formatWithSpaces
                  }}

                </span>
              </td>


            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td></td>
              <td></td>
              <td class="text-end">
                <span class="text-end bg-danger rounded px-2 py-1 text-white">
                  {{ parseFloat(top10TotalUnpaidSum).toFixed(2) | formatWithSpaces }}
                </span>
              </td>
              <td class="d-xl-flex d-none"></td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div class="col-xl-6 col-12 row p-1">
        <div class="col-8 mx-auto">
          <vue-pie-chart :chart-data="pieChartData"  />
        </div>
      </div>
    </div>

    <div  class="row">

      <div class="col-xl-3 align-items-stretch text-secondary p-2 " 
      v-for="(section, index) in sections" :key="index">
        <div class="shadow rounded p-3 h-100">
          <div class="row" v-for="(item, itemIndex) in section.items" :key="itemIndex">
            <div class="col">
              {{ item.label }}
            </div>
            <div class=" col-auto">
              <span v-if="totalTodays[section.key]" :class="item.color">
                {{ totalTodays[section.key][item.value] | formatWithSpaces }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br />
    <br />
    <div  class="row align-items-stratch">


      <!-- <div class="col-xl-12">
        <line-chart :chart-data="lineChartData" :options="lineChartOptions"></line-chart>
      </div> -->


    </div>
    <br />
    <br />

    <div class="row p-1">
      <div class="col-7">
        <div class="row align-items-end">
          <div class="col-xl-4">
            <label for="">Du</label>
            <input type="date" v-model="filter.startDate" class="form-control">
          </div>
          <div class="col-xl-4">
            <label for="">Au</label>
            <input type="date" v-model="filter.endDate" class="form-control">
          </div>

          <div class="col-xl-4">
            <label for=""></label>
            <button @click="filterQuantityData(filter)" class="btn btn-secondary">
              Rechercher
            </button>
          </div>
        </div>
        <br>
       <vue-data-table
    :headers="headers"
    :data="quantityAnalytics"
    :items-per-page="10"
    :summable-columns="summableColumns"
  >
    <!-- Production -->
    <template #cell-productedQuantity="{ row }">
      <span
        class="fw-bold px-2 py-1 rounded"
        :class="
          parseFloat(row.productedQuantity) == 0
            ? 'bg-light-light text-dark'
            : parseFloat(row.productedQuantity) > 0
              ? 'bg-light-success text-success'
              : 'bg-light-light text-primary'
        "
      >
        + {{ parseFloat(row.productedQuantity).toFixed(3) }}
      </span>
    </template>

    <!-- Vendue -->
    <template #cell-soldQuantity="{ row }">
      <span
        class="fw-bold px-2 py-1 rounded"
        :class="
          parseFloat(row.soldQuantity) == 0
            ? 'bg-light-light text-dark'
            : parseFloat(row.soldQuantity) > 0
              ? 'bg-light-danger text-danger'
              : 'bg-light-light text-primary'
        "
      >
        - {{ parseFloat(row.soldQuantity).toFixed(3) }}
      </span>
    </template>

    <!-- Stock -->
    <template #cell-stockQuantity="{ row }">
      <span
        class="fw-bold px-2 py-1 rounded"
        :class="
          parseFloat(row.stockQuantity) == 0
            ? 'bg-light-light text-dark'
            : parseFloat(row.stockQuantity) > 0
              ? 'bg-light-success text-success'
              : 'bg-light-danger text-danger'
        "
      >
        {{ parseFloat(row.stockQuantity).toFixed(3) }}
      </span>
    </template>
  </vue-data-table>

      </div>
      <div class="col-5">
        <vue-pie-chart :chart-data="soldQuantityChartData" :options="soldQuantityChartOptions" />
      </div>
    </div>
    <br />

    

  </div>
</template>
<script>
import { mapGetters } from "vuex";
import BarChartVue from "../components/chart/BarChart.vue";
import BarChartSalesTodayVue from "../components/chart/BarChartSalesToday.vue";
import LineChart from "../components/chart/LineChart.vue";
import ScatterChart from "../components/chart/ScatterChart.vue";
import moment from "moment";
export default {
  components: {
    BarChartVue,
    ScatterChart,
    LineChart,
    BarChartSalesTodayVue,
  },
  data() {
    return {
      sections: [
        {
          key: 'sales',
          items: [
            { label: 'Total Ventes Aujourd\'hui', icon: 'bi bi-cart3', value: 'priceTotalTTCSale', color: 'text-primary' },
            { label: 'Total Ventes Payé', icon: 'bi bi-window-x', value: 'totalPaidSale', color: 'text-success' },
            { label: 'Total Ventes Impayé', icon: 'bi bi-window-dash', value: 'totalUnpaidSale', color: 'text-danger' },
            { label: 'Règlement Ventes Impayé', icon: 'bi bi-cash-stack', value: 'totalPaidOldBillSale', color: 'text-warning' },
            { label: 'Ventes Payé Espèces', icon: 'bi bi-cash', value: 'totalCashSale', color: 'text-success' },
            { label: 'Ventes Payé Virements', icon: 'bi bi-bank', value: 'totalBankTransferSale', color: 'text-danger' },
            { label: 'Ventes Payé Chèques', icon: 'bi bi-cash-coin', value: 'totalCheckSale', color: 'text-warning' },
          ]
        },
        {
          key: 'purchases',
          items: [
            { label: 'Total Achats d\'aujourd\'hui', icon: 'bi bi-cart3', value: 'priceTotalTTCPurchase', color: 'text-primary' },
            { label: 'Total Achats Payé', icon: 'bi bi-window-x', value: 'totalPaidPurchase', color: 'text-success' },
            { label: 'Total Achats Impayé', icon: 'bi bi-window-dash', value: 'totalUnpaidPurchase', color: 'text-danger' },
            { label: 'Règlement Achats Impayé', icon: 'bi bi-cash-stack', value: 'totalPaidOldBillPurchase', color: 'text-warning' },
            { label: 'Achats Payé Espèces', icon: 'bi bi-cash', value: 'totalCashPurchase', color: 'text-success' },
            { label: 'Achats Payé Virements', icon: 'bi bi-bank', value: 'totalBankTransferPurchase', color: 'text-danger' },
            { label: 'Achats Payé Chèques', icon: 'bi bi-cash-coin', value: 'totalCheckPurchase', color: 'text-warning' },
          ]
        },
        {
          key: 'expenses',
          items: [
            { label: 'Total Dépenses Aujourd\'hui', icon: 'bi bi-cart3', value: 'priceTotalTTCExpense', color: 'text-primary' },
            { label: 'Dépenses Payé Espèces', icon: 'bi bi-cash', value: 'totalCashExpense', color: 'text-success' },
            { label: 'Dépenses Payé Virements', icon: 'bi bi-bank', value: 'totalBankTransferExpense', color: 'text-danger' },
            { label: 'Dépenses Payé Chèques', icon: 'bi bi-cash-coin', value: 'totalCheckExpense', color: 'text-warning' },
          ]
        },
        {
          key: 'transactions',
          items: [
            { label: 'Total Transactions Aujourd\'hui', icon: 'bi bi-receipt', value: 'priceTotalTTCTransaction', color: 'text-primary' },
            { label: 'Transactions Payé Espèces', icon: 'bi bi-cash', value: 'totalCashTransaction', color: 'text-success' },
            { label: 'Transactions Payé Virements', icon: 'bi bi-bank', value: 'totalBankTransferTransaction', color: 'text-danger' },
            { label: 'Transactions Payé Chèques', icon: 'bi bi-cash-coin', value: 'totalCheckTransaction', color: 'text-warning' },
          ]
        },
      ],
      filter: {
        startDate: "",
        endDate: ""
      },
      headers: [
        { field: "fullName", label: "Désignation" },
        { field: "productedQuantity", label: "Quantité Produite" },
        { field: "soldQuantity", label: "Quantité Vendue" },
        { field: "stockQuantity", label: "Quantité en Stock" },
      ],
      summableColumns: [
        { field: "productedQuantity", class: "text-dark" },
        { field: "soldQuantity", class: "text-danger" },
        { field: "stockQuantity", class: "text-success" },
      ],

    };
  },
  computed: {
    ...mapGetters("statistic", {
      totalTodays: "getTotalTodays",
      allTotals: "getTotals",
      // barTodaysChartData: "getBarTodaysChartData",
      quantityAnalytics: "getQuantityAnalytics",
      deliveries: "getDeliveries",
    }),

    ...mapGetters("credit", {
      credits: "getCredits",

    }),
    ...mapGetters("sale", {
      invoices: "getAll",
    }),

   
   pieChartData() {
  let paid = 0;
  let unpaid = 0;

  this.invoices.forEach(inv => {
    const amountPaid = parseFloat(inv.amountPaid) || 0;
    const amountUnpaid = parseFloat(inv.amountUnpaid) || 0;

    paid += amountPaid;
    unpaid += amountUnpaid;
  });

  return {
    labels: ["Payé", "Impayé"],
    datasets: [
      {
        backgroundColor: ['#4CAF50', '#F44336'],
        data: [paid, unpaid]
      }
    ]
  };
}
,


    pieChartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'bottom'
          }
        }
      };
    },

    lineChartData() {
      const today = new Date();
      const startDate = new Date();
      startDate.setDate(today.getDate() - 19); // 20 jours en tout

      const totals = {};
      for (let i = 0; i < 20; i++) {
        const date = new Date(startDate);
        date.setDate(startDate.getDate() + i);
        const formatted = date.toISOString().split('T')[0];
        totals[formatted] = {
          total: 0,
          paid: 0,
          unpaid: 0
        };
      }

      this.invoices.forEach(inv => {
        const invoiceDate = new Date(inv.date || inv.saleDate);
        const formatted = invoiceDate.toISOString().split('T')[0];
        if (totals[formatted]) {
          totals[formatted].total += parseFloat(inv.totalPriceTTC) || 0;
          totals[formatted].paid += parseFloat(inv.amountPaid) || 0;
          totals[formatted].unpaid += parseFloat(inv.amountUnpaid) || 0;
        }
      });

      return {
        labels: Object.keys(totals),
        datasets: [
          {
            label: this.$t("Total TTC"),
            backgroundColor: '#42A5F5',
            borderColor: '#42A5F5',
            fill: false,
            tension: 0.3,
            data: Object.values(totals).map(item => parseFloat(item.total))
          },
          {
            label: this.$t("Montant payé"),
            backgroundColor: '#66BB6A',
            borderColor: '#66BB6A',
            fill: false,
            tension: 0.3,
            data: Object.values(totals).map(item => parseFloat(item.paid))
          },
          {
            label: this.$t("Montant impayé"),
            backgroundColor: '#EF5350',
            borderColor: '#EF5350',
            fill: false,
            tension: 0.3,
            data: Object.values(totals).map(item => parseFloat(item.unpaid))
          }
        ]
      };
    },


    lineChartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            position: 'bottom'
          }
        },
        scales: {
          x: {
            ticks: {
              maxRotation: 90,
              minRotation: 45
            }
          },
          y: {
            beginAtZero: true
          }
        }
      };
    },


    soldQuantityChartData() {
      const soldCounts = {};

      this.quantityAnalytics.forEach(item => {
        const label = item.fullName || 'Inconnu';
        const quantity = item.stockQuantity || 0;

        if (label.toUpperCase().includes("MANUTENTION")) {
          return; // Exclure les entrées contenant "MANUTENTION"
        }

        if (!soldCounts[label]) {
          soldCounts[label] = 0;
        }

        soldCounts[label] += quantity;
      });

      return {
        labels: Object.keys(soldCounts),
        datasets: [
          {
            backgroundColor: [
              '#4CAF50', '#FFC107', '#03A9F4', '#F44336',
              '#9C27B0', '#009688', '#E91E63', '#00BCD4'
            ],
            data: Object.values(soldCounts)
          }
        ]
      };
    },


    soldQuantityChartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'bottom'
          }
        }
      };
    },


    top10Credits() {
      if (!this.credits) return [];
      var sortedCredits = this.credits.sort((a, b) => b.totalUnpaid - a.totalUnpaid);
      return sortedCredits.slice(0, 10);
    },
    top10TotalUnpaidSum() {
      if (!this.top10Credits) return 0;
      return this.top10Credits.reduce((acc, credit) => acc + credit.totalUnpaid, 0);
    },

  },
  async mounted() {
    await this.$store.dispatch("statistic/fetchTotalTodays");
    await this.$store.dispatch("statistic/fetchTotals");
    await this.$store.dispatch("statistic/fetchQuantityAnalytics", moment(new Date()).format("YYYY-MM-DD"));
    await this.$store.dispatch("credit/getAll");
    await this.$store.dispatch("sale/filter", {});
  },
  methods: {
    async refresh() {
      await this.$store.dispatch("statistic/fetchTotals");
      await this.$store.dispatch("statistic/fetchTotalTodays");
      await this.$store.dispatch(
        "statistic/fetchQuantityAnalytics",
        moment(new Date()).format("YYYY-MM-DD")
      );
      await this.$store.dispatch("credit/getAll");
      await this.$store.dispatch("sale/filter", {});

    },
    async filterQuantityData(filter) {
      await this.$store.dispatch("statistic/fetchQuantityAnalytics", filter);
    }
  },
  filters: {
    formatWithSpaces(value) {
      // Ensure the value is a number and fix it to 2 decimal places
      const fixedValue = Number(value).toFixed(2);
      // Convert the fixed number to a string and apply spaces as thousands separators
      return fixedValue.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
  },

};
</script>
